<template>
  <div>
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.group_name" placeholder="Name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading"
      element-loading-text="Loading..." style="width: 1200px;">
      <el-table-column prop="group_name" label="Name" width="100" align="center">
      </el-table-column>
      <el-table-column prop="group_auth" label="Detail">
        <template slot-scope="scope">
          <div>{{scope.row.group_auth|replaceD}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" v-if="scope.$index>0" type="danger" @click="deleteUser(scope.$index, scope.row)">Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Name" prop="group_name">
          <el-input size="small" v-model="editForm.group_name" auto-complete="off" placeholder="Please enter a name" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Detail" prop="group_auth">
          <el-checkbox border size="small" :indeterminate="isIndeterminate" v-model="checkAll"
            @change="handleCheckAllChange">All
          </el-checkbox>
          <div style="margin-bottom: 7px"></div>
          <div v-for="(menu,keys) in leftMenu" :key="keys">
            <el-checkbox-group v-model="editForm.group_auth" @change="handleGroupAuthChange">
              <span class="check_span">{{menu.menuname}}</span>
              <el-checkbox v-for="(child,k) in menu.menus" :key="k" :label="child.menuname">
                {{child.menuname}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    systemUserGroupList,
    systemUserGroupSave,
    systemUserGroupDelete,
  } from '../../api/apiFun'
  import {
    timestampToTime,
    leftMenu
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制Edit页面显示与隐藏
        title: 'Add',
        editForm: {
          id: '',
          group_name: '',
          group_auth: []
        },
        // rules 表单验证
        rules: {
          group_name: [{
            required: true,
            message: 'Please enter a permission name',
            trigger: 'blur'
          }],
          group_auth: [{
            required: true,
            message: 'Please Set up permission details',
            trigger: 'blur'
          }],
        },
        params: {
          page: 1,
          limit: 10,
          group_name: ''
        },
        listData: [], //User数据
        // 选中
        checkmenu: [],
        //参数role
        saveid: '',
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        leftMenu: [],
        leftMenuChild: [],
        isIndeterminate: true,
        checkAll: false,
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
      replaceD: function (str) {
        return str.replace(/,/g, '，')
      }
    },

    created() {
      this.leftMenu = leftMenu;
      this.leftMenu.forEach(element => {
        element.menus.forEach(e => {
          this.leftMenuChild.push(e.menuname);
        });
      });
      this.getdata(this.params)
    },

    /**
     * 里面的方法只有被调用才会执行
     */

    methods: {
      // 获取权限列表
      getdata(parameter) {
        this.loading = true
        systemUserGroupList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get permission list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      handleCheckAllChange(val) {
        this.editForm.group_auth = val ? this.leftMenuChild : [];
        this.isIndeterminate = false;
      },
      handleGroupAuthChange(value) {


        let checkedCount = value.length;
        this.checkAll = checkedCount === this.leftMenuChild.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.leftMenuChild.length;
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = 'Edit'
          this.editForm.id = row.id
          this.editForm.group_name = row.group_name
          this.editForm.group_auth = row.group_auth ? row.group_auth.split(',') : []
          var auth_arr = row.group_auth ? row.group_auth.split(',') : []
          let checkedCount = auth_arr.length;
          this.checkAll = checkedCount === this.leftMenuChild.length;
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.leftMenuChild.length;
        } else {
          this.title = 'Add'
          this.editForm.id = ''
          this.editForm.group_name = ''
          this.editForm.group_auth = []
        }
      },
      // Edit、增加页面Save方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            this.loading = true
            // console.log(this.editForm);
            // return
            systemUserGroupSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.params)
                this.$message({
                  type: 'success',
                  message: 'Saved successfully'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Saving failed, please try again later!')
            })
          } else {
            return false
          }
        })
      },
      // 删除权限
      deleteUser(index, row) {
        this.$confirm('Are you sure you want to delete?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          systemUserGroupDelete({
            id: row.id,
            group_name: row.group_name
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'successfully deleted!'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Deletion failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Undelete'
          })
        })
      },
      // closeEdit、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        } else if (dialog == 'perm') {}
      }
    }
  }

</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .check_span {
    font-size: 14px;
    color: #c0c4cc;
    border: 1px solid #dcdfe6;
    padding: 0px 15px;
    box-sizing: border-box;
    display: inline-block;
    border-radius: 3px;
    height: 32px;
    cursor: not-allowed;
    line-height: 32px;
    font-weight: 500;
    white-space: nowrap;
    user-select: none;
    margin-right: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/views/system/system_user_group.vue